import React from 'react'

import KledoMark from 'assets/images/kledo-mark.svg?react'

import styles from './style.module.scss'

const KledoLoader = ({ size = 48, className = '' }) => {
  return (
    <span
      className={`${styles.loader} ${className}`.trim()}
      style={{ width: size, height: size }}
      role="status"
    >
      <KledoMark />
    </span>
  )
}

export default KledoLoader
